export class WebhookV1StandardPayloadClassificationJobFailed {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadClassificationJobFailedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadClassificationJobFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadClassificationJobFailed.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadClassificationJobFailedTypeEnum;
(function (WebhookV1StandardPayloadClassificationJobFailedTypeEnum) {
    WebhookV1StandardPayloadClassificationJobFailedTypeEnum["ClassificationJobFailed"] = "CLASSIFICATION_JOB_FAILED";
})(WebhookV1StandardPayloadClassificationJobFailedTypeEnum || (WebhookV1StandardPayloadClassificationJobFailedTypeEnum = {}));
